// @owners { team: patients-team }
import { INITIAL_TIP_AMOUNT } from './constants';

type GetTargetCheckoutTipAmountParams = {
  isEditingOrder: boolean;
  isTippable: boolean;
  existingTipAmount: number | null | undefined;
};

/**
 * Returns the tip amount that should be stored on the order for the current checkout state.
 * Edit orders preserve the existing tip unless the patient changes it.
 * New orders default to INITIAL_TIP_AMOUNT when eligible, and clear when ineligible.
 */
export const getTargetCheckoutTipAmount = ({
  isEditingOrder,
  isTippable,
  existingTipAmount,
}: GetTargetCheckoutTipAmountParams): number | undefined => {
  if (!isTippable) {
    return shouldClearTipWhenIneligible(isEditingOrder) ? undefined : (existingTipAmount ?? undefined);
  }

  if (isEditingOrder) {
    return typeof existingTipAmount === 'number' ? existingTipAmount : undefined;
  }

  if (typeof existingTipAmount === 'number') {
    return existingTipAmount;
  }

  return INITIAL_TIP_AMOUNT;
};

export const shouldClearTipWhenIneligible = (isEditingOrder: boolean): boolean => !isEditingOrder;

/** Whether the order has a tip amount that requires a tip payment method. */
export const hasCheckoutTip = (tipAmount: number | null | undefined): boolean => (tipAmount ?? 0) > 0;
